module.exports = __webpack_public_path__ + "static/media/lucky-wheel-img-2.431c8a0f.png";